/* eslint-disable react-hooks/exhaustive-deps */
import './SettingsCounselor.css';
import React from 'react';
import { Button, Col, Spinner } from 'react-bootstrap';
import { Typography } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ChatBubbleOutline from '@mui/icons-material/ChatBubbleOutline';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import CheckBoxOutlined from '@mui/icons-material/CheckBoxOutlined';
import HistoryOutlined from '@mui/icons-material/HistoryOutlined';
import ArrowUpward from '@mui/icons-material/ArrowUpward';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import PersonAddAltOutlinedIcon from 'components/icons/PersonAddAltOutlinedIcon';
import TextIconInput from 'components/input/TextIconInput';
import PersonOutlinedIcon from 'components/icons/PersonOutlinedIcon';
import SelectInput from 'components/input/SelectInput';
import { INVITATION_STATUS, USER_ROLE } from 'constants/common';
import { catName, toTitleCase, toLocalShortDate, setArrayLength } from 'components/helper/helper';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import partnerServices from 'services/partnerServices';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import collegeServices from 'services/collegeServices';
import Cookies from 'js-cookie';
import { useHistory, useLocation } from 'react-router-dom';
import { routers } from 'router/router';
import { getContactDetail, logout } from 'app/basicInformationSlice/basicInformationSlice';
import { getHighSchool, updateHighSchool } from 'app/highSchoolSlice/highSchoolSlice';
import { scrollToObject } from 'components/helper/ui_helper';
import CounselorInviteAlertDialog from 'screen/education/highSchool/components/CounselorInviteAlertDialog';
import { getAccessToken, getUserId, getUserRole, removeAccessToken, removeUserId } from 'utils/sessionStorage';
import { useChatList } from 'components/layout/ChatListContext';
import toast from 'react-hot-toast';

interface Props {}

const SettingsCounselor = (props: Props) => {
  let token = getAccessToken();
  const dispatch:any = useAppDispatch();
  const location = useLocation();
  const history = useHistory();
  const { refreshChatList } = useChatList();
  const [waiting, setWaiting] = React.useState(false);
  const [currentRow, setCurrentRow] = React.useState<any>();
  const [showSession, setShowSession] = React.useState(3);
  const [userRole, setUserRole] = React.useState('');
  const [highSchoolInfo, setHighSchoolInfo] = React.useState<any>();
  const [currentCounselor, setCurrentCounselor] = React.useState<any>();
  const [partnerList, setPartnerList] = React.useState<any[]>([]);
  const [refershList, setRefershList] = React.useState(true);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [showAlert, setShowAlert] = React.useState(false);
  const [counselorListAction, setCounselorListAction] = React.useState<
    'approve' | 'decline' | 'remove' | null
  >(null);

  const [itemsPerPage] = React.useState(10);
  const personalStore = useAppSelector((store) => store.basicInformation.myBasicInformation);
  const studentId = personalStore?.student_id ??  getUserId();
  const DEMO_STUDENT = process.env.REACT_APP_STUDENT_DEMO || 'student-demo@gradmap.com';
  const hash = location.hash.slice(1); // Remove the '#' character from the hash
  var bInviteCouselor:boolean = (hash === 'invite_couselor');

  const apiErrorMessage = (error: unknown, fallback: string): string => {
    const e = error as { response?: { data?: { message?: string } }; message?: string };
    if (e?.response?.data?.message) {
      return e.response.data.message;
    }
    if (typeof e?.message === 'string' && e.message) {
      return e.message;
    }
    return fallback;
  };

  // current counselor formkik for Student only
  const currentformik = useFormik({
    initialValues: {
      counselor_first_name: '',
      counselor_last_name: '',
      counselor_role: USER_ROLE.counselor,
      counselor_email: '',
    },
    validationSchema: Yup.object({
      counselor_first_name: Yup.string(),
      counselor_last_name: Yup.string(),
      counselor_email: Yup.string().email('Invalid email').required('Required'),
    }),
    onSubmit: async (values) => {
      setWaiting(true);

      try {
        const counselorPartnerId =
          currentCounselor?.student_id ?? currentCounselor?.id ?? currentCounselor?.partner_id;
        if (counselorPartnerId == null || counselorPartnerId === '') {
          toast.error('Missing counselor account id.');
          setWaiting(false);
          return;
        }
        await partnerServices.updatePartnerInviteStatus(
          studentId,
          counselorPartnerId,
          INVITATION_STATUS.withdrawn
        );

        const err = {
          counselor_first_name: '',
          counselor_last_name: '',
          counselor_role: '',
          counselor_email: `The Counselor had been removed successfully.`,
        };
        currentformik.setErrors(err);
        bInviteCouselor = false;
        setShowAlert(false);
        gotoSettingCouselor(); // force remmove #tag
        window.location.reload();
      } catch (ex) {
        const err = {
          counselor_first_name: '',
          counselor_last_name: '',
          counselor_role: '',
          counselor_email: apiErrorMessage(ex, 'Could not update counselor.'),
        };

        currentformik.setErrors(err);
      }
      setWaiting(false);
    },
  });

  // new counselor formik
  const formik = useFormik({
    initialValues: {
      counselor_first_name: '',
      counselor_last_name: '',
      counselor_role: USER_ROLE.counselor,
      counselor_email: '',
    },
    validationSchema: Yup.object({
      counselor_first_name: Yup.string(),
      counselor_last_name: Yup.string(),
      counselor_email: Yup.string().email('Invalid email').required('Required'),
    }),
    onSubmit: async (values) => {
      token = getAccessToken();
      if (token && studentId) {
        setWaiting(true);
        try {
          await partnerServices
            .inviteCounselor(studentId, formik.values.counselor_email)
            .then(async (res) => {
              let obj = res.result;
               if (obj) {
                collegeServices.sendMailInvite({
                  email: formik.values.counselor_email,
                  username: formik.values.counselor_first_name,
                  studentFirstname: personalStore.first_name,
                  studentLastname: personalStore.last_name,
                });
  
                const err = {
                  counselor_first_name: '',
                  counselor_last_name: '',
                  counselor_role: '',
                  counselor_email: `The Counselor was invited successfully.`,
                };
  
                formik.setErrors(err);

                setTimeout(() => {
                  const role: string = (personalStore?.user_role ?? '').toLowerCase();
                  loadCurrentCounselor(role);
                  setShowSession(1);
                }, 1000);
              }
  
              setTimeout(() => {            
                bInviteCouselor = false;
                setShowAlert(false);
                gotoSettingCouselor(); // force remmove #tag
                getDetail();
                refreshChatList();
                ///window.location.reload();
              }, 1000);
            });
        } 
        catch (ex) {
          const err = {
            counselor_first_name: '',
            counselor_last_name: '',
            counselor_role: '',
            counselor_email: apiErrorMessage(ex, 'Could not send invitation.'),
          };
  
          formik.setErrors(err);
        }
        setWaiting(false);
      }
      else {
        handleLogout();
      }
    },
  });

  const loadCurrentCounselor = (role: string, bUpdate: boolean = false) => {
    try {
      partnerServices.getCurrentCounselor(studentId).then(async (res) => {
        if (res && res.length > 0) {
          if (role === USER_ROLE.student) {
            let obj = res[0];
            if (
              obj &&
              (obj.requested_status === INVITATION_STATUS.pending ||
                obj.requested_status === INVITATION_STATUS.approved)
            ) {
              currentformik.setValues({
                counselor_first_name: obj.first_name,
                counselor_last_name: obj.last_name,
                counselor_role: obj.user_role,
                counselor_email: obj.email,
              });
              setCurrentCounselor(obj);
              setShowSession(1);
              if (bUpdate) {
                let highschool:any = await dispatch(getHighSchool(studentId)).unwrap();
                if (highschool) {
                  const newValues:any = Object.assign({}, highschool);
                  newValues.counselor_first_name = obj.first_name;
                  newValues.counselor_last_name = obj.last_name;
                  newValues.counselor_email = obj.email;
                  await dispatch(updateHighSchool(newValues));
                }
              }
              else {
                if (bInviteCouselor) {
                  setShowAlert(true);
                }
                else {
                  setShowAlert(false);
                }
              }
            }
          }
        }
      });
    } catch (ex) {}
  };

  const renderDate = (timestamp: string) => {
    try {
      if (timestamp && timestamp.length > 11) {
        let date = new Date(timestamp.substring(0, 11));
        return toLocalShortDate(date);
      }
    } catch (ex) {
      if (timestamp && timestamp.length > 11) {
        let year = timestamp?.substring(0, 4) ?? '';
        let month = timestamp?.substring(6, 2) ?? '';
        let day = timestamp?.substring(9, 2) ?? '';
        return `$${month}/${day}/${year}`;
      }
    }
    return '';
  };

  const renderInvitedStatus = (item: any) => {
    try {
      if (item) {
        let status = item.requested_status;
        if (item.requested_status === INVITATION_STATUS.approved) status = 'Invited';
        if (item.requested_status === INVITATION_STATUS.pending) status = 'Pending Invited';

        return renderDate(item.invited_date) + ': ' + toTitleCase(status);
      }
    } catch (ex) {}
    return '';
  };

  const loadParnerList = () => {
    try {
      partnerServices.getInvitePartnerList(studentId).then((res) => {
        if (res && res.length > 0) {
          let arr: any[] = res.filter((o:any) => o.email !== DEMO_STUDENT);
          arr = arr.filter((r:any)=> r.requested_status === INVITATION_STATUS.approved ||
                                     r.requested_status === INVITATION_STATUS.pending);         
          
          const mockData = arr.map(item => ({
            ...item,
            processState: 'No Process',
            chat: Math.floor(Math.random() * 5),
            notes: Math.floor(Math.random() * 6),
            todos: Math.floor(Math.random() * 4),
            lastActivity: 'No activity'
          }));
          setPartnerList(mockData);

        } else {
          setPartnerList([]);
        }
      });
    } catch (ex) {}
  };

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const getDetail = async () => {

    token = getAccessToken();
    if (token && studentId) {
      const res = await dispatch(getHighSchool(studentId)).unwrap();
      if (res) {
          if (bInviteCouselor) {
            formik.setFieldValue("counselor_first_name", res?.counselor_first_name ?? '');
            formik.setFieldValue("counselor_last_name", res?.counselor_last_name ?? '');
            formik.setFieldValue("counselor_email", res?.counselor_email ?? '');
          }
      }
      setHighSchoolInfo(res);

      const role: string = personalStore?.user_role ?? '';
      setShowSession(2);
      if (role && role.length > 0) {
        setUserRole(role);
        if (role === USER_ROLE.student) {
          setShowSession(2);
          if (studentId) {
            loadCurrentCounselor(role);
          }
        } else if (role === USER_ROLE.counselor) {
          setShowSession(4);
          if (refershList) {
            loadParnerList();
            setRefershList(false);
          }
        } else {
        }
      }

      if (bInviteCouselor) {
        scrollToObject('go-to-bottom', 0);
      }


    } else {
      handleLogout();
    }
  };

  React.useEffect(() => {
    getDetail();
  }, [personalStore?.id, personalStore?.user_role, refershList]);

  const handleAddNew = function () {
    setShowSession(2);
  };


  const gotoSettingCouselor = () => {
    try {
        let path = `${routers.settings.path}?active-tab=3`;
        history.push(path);
      }
      catch(ex){
        console.log('Error: ', ex);
      }
  }   


  const handleApproval = async (item: any) => {
    if (item && item?.requested_status === INVITATION_STATUS.pending) {
      setWaiting(true);
      setCounselorListAction('approve');
      setCurrentRow(item);
      const counselorPartnerId = Number(studentId);
      try {
        await partnerServices.updatePartnerInviteStatus(
          item.student_id,
          counselorPartnerId,
          INVITATION_STATUS.approved
        );
        // await partnerServices.sync(item?.email);
        setRefershList(true);
        refreshChatList();
        toast.success('Invitation approved successfully.');
      } catch {
        // http.tsx interceptor already toasts responseData.message for failed requests
      } finally {
        setWaiting(false);
        setCounselorListAction(null);
      }
    }
  };

  const handleDeclinePending = async (item: any) => {
    if (item && item?.requested_status === INVITATION_STATUS.pending) {
      setWaiting(true);
      setCounselorListAction('decline');
      setCurrentRow(item);
      const counselorPartnerId = Number(studentId);
      try {
        await partnerServices.updatePartnerInviteStatus(
          item.student_id,
          counselorPartnerId,
          INVITATION_STATUS.declined
        );
        // await partnerServices.sync(item?.email);
        setRefershList(true);
        refreshChatList();
        toast.success('Invitation declined successfully.');
      } catch {
        // http.tsx interceptor already toasts responseData.message for failed requests
      } finally {
        setWaiting(false);
        setCounselorListAction(null);
      }
    }
  };

  const handleRemove = async (item: any) => {
    if (item && item?.requested_status === INVITATION_STATUS.approved) {
      setWaiting(true);
      setCounselorListAction('remove');
      setCurrentRow(item);
      const counselorPartnerId = Number(studentId);
      try {
        await partnerServices.updatePartnerInviteStatus(
          item.student_id,
          counselorPartnerId,
          INVITATION_STATUS.removed
        );
        // await partnerServices.sync(item?.email);
        setRefershList(true);
        refreshChatList();
        toast.success('Student removed successfully.');
      } catch {
        // http.tsx interceptor already toasts responseData.message for failed requests
      } finally {
        setWaiting(false);
        setCounselorListAction(null);
      }
    }
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = partnerList.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(partnerList.length / itemsPerPage);

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };


  return (
    <div className="tab-wrap-panel">
      <div className="tab-panel">
        <div className="text-left" style={{ paddingBottom: '16px' }}>
          <div className="row">
            <div className="col-md-12">
              <div className="d-flex align-items-center">
                <div
                  className="text-primary p-2 rounded-circle bg-primary-light d-flex align-items-center justify-content-center"
                  style={{ width: '35px', height: '35px', marginRight: '8px' }}
                >
                  <PersonAddAltOutlinedIcon
                    className="text-primray-light"
                    width={'18px'}
                    height={'18px'}
                  />
                </div>
                <div className="text-primary fs-4 fw-bold mx-1">
                  {getUserRole() === 'counselor' ? (
                    <span>Student Invites</span>
                  ):(
                    <span>List of Invited Couselor</span>
                  )}
                </div>
              </div>
            </div>
          </div>

          {userRole === USER_ROLE.student && showSession === 1 && (
            <div id="list-current-counselor" className="border rounded"
              style={{ padding: '16px', marginTop: '24px', marginBottom: '24px' }}
            >
              <div className="row">
                <div className="col-md-12">
                  <h3 className="fs-16px">Current Counselor</h3>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 py-2 px-2">
                  <TextIconInput
                    disabled={true}
                    icon={<PersonOutlinedIcon />}
                    iconClass="text-primary3"
                    formClass="text-field-dark border-field-dark"
                    mdCol={'6'}
                    label={'First name'}
                    name={'counselor_first_name'}
                    values={currentformik.values.counselor_first_name}
                    onChange={currentformik.handleChange}
                  />
                </div>
                <div className="col-md-6 py-2 px-2">
                  <TextIconInput
                    disabled={true}
                    icon={<PersonOutlinedIcon />}
                    iconClass="text-primary3"
                    formClass="text-field-dark border-field-dark"
                    mdCol={'6'}
                    label={'Last name'}
                    name={'counselor_last_name'}
                    values={currentformik.values.counselor_last_name}
                    onChange={currentformik.handleChange}
                  />
                </div>
              </div>
              <div className="d-flex align-items-start row mt-2">
                <div className="col-md-6 py-2 px-2">
                  <SelectInput
                    disabled={true}
                    mdCol={'6'}
                    form={currentformik}
                    values={currentformik.values.counselor_role}
                    onChange={currentformik.handleChange}
                    name={'counselor_role'}
                    label={'User Role'}
                    option={[
                      { value: USER_ROLE.student, name: 'Student', disabled: 'disabled' },
                      { value: USER_ROLE.counselor, name: 'Counselor', disabled: 'disabled' },
                    ]}
                    feedback={
                      currentformik.touched.counselor_role &&
                      currentformik.errors.counselor_role &&
                        <span className="text-danger">{currentformik.errors.counselor_role}</span>
                    }
                  />
                </div>
                <div className="col-md-6 py-2 px-2">
                  <TextIconInput
                    disabled={true}
                    icon={<MailOutlineIcon />}
                    iconClass="text-primary3"
                    formClass="text-field-dark border-field-dark"
                    mdCol={'6'}
                    label={'Email*'}
                    name={'counselor_email'}
                    values={currentformik.values.counselor_email}
                    onChange={currentformik.handleChange}
                    feedback={
                      currentformik.touched.counselor_email &&
                      currentformik.errors.counselor_email && (
                        <span id="error_email" className="text-danger">
                          {currentformik.errors.counselor_email}
                        </span>
                      )
                    }
                  />
                </div> 
              </div>

              <div className="row py-2">
                <div className="col-md-12 mt-2 px-1">
                    <span className="text-left text-secondary fs-13px">By inviting your counselor, you are allowing your counselor to view all your GradMap summary pages and the information on them. 
                    It will enable you to access and use the chat feature to communicate with your counselor.
                    </span>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="p-0 p-md-1 d-md-flex align-items-end"
                    style={{ paddingLeft: 0, justifyContent: 'space-between' }}
                  >
                    <div className="fs-13px text-field-ultralight py-2">
                      {renderInvitedStatus(currentCounselor)}
                    </div>
                    <Button
                      variant="outline-danger"
                      onClick={async () => currentformik.handleSubmit()}
                      className="btn-update"
                    >
                      {waiting ? (
                        <Spinner size="sm" animation="border" variant="light" />
                      ) : ('Remove')}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {userRole === USER_ROLE.student && showSession === 2 && (
            <>
              <div
                className="rounded border border-primary bg-primary-light border-2 d-flex flex-column flex-md-row align-items-center mt-3"
                style={{
                  minHeight: '114px',
                  paddingLeft: '31px',
                  paddingRight: '25px',
                  justifyContent: 'space-between',
                }}
              >
                <div className="d-flex align-items-center">
                  <PersonAddAltOutlinedIcon
                    className="text-primary"
                    width={'51px'}
                    height={'51px'}
                    style={{ fontSize: 47, minWidth: '51px', marginRight: '22px' }}
                  ></PersonAddAltOutlinedIcon>
                  <span
                    className="text-primary"
                    style={{
                      fontSize: '16px',
                      lineHeight: '22px',
                      letterSpacing: '0.02em',
                      maxWidth: '506px',
                      marginRight: '22px',
                      marginTop: '22px',
                      marginBottom: '22px',
                    }}
                  >
                    Add a counselor to accompany you in this process, it can be one of your parents,
                    your guardian / tutor or your counselor
                  </span>
                </div>
              </div>

              <div
                id="new-counselor"
                style={{ padding: '16px', marginTop: '16px' }}
                className="border rounded"
              >
                <div className="row">
                  <div className="col-md-12">
                    <h3 className="fs-16px">Counselor</h3>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6 py-2 px-2">
                    <TextIconInput
                      icon={<PersonOutlinedIcon />}
                      iconClass="text-field-light"
                      formClass="text-field-light border-field-light"
                      mdCol={'6'}
                      label={'First name'}
                      name={'counselor_first_name'}
                      values={formik.values.counselor_first_name}
                      onChange={formik.handleChange}
                    />
                  </div>
                  <div className="col-md-6 py-2 px-2">
                    <TextIconInput
                      icon={<PersonOutlinedIcon />}
                      iconClass="text-field-light"
                      formClass="text-field-light border-field-light"
                      mdCol={'6'}
                      label={'Last name'}
                      name={'counselor_last_name'}
                      values={formik.values.counselor_last_name}
                      onChange={formik.handleChange}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 py-2 px-2">
                    <SelectInput
                      disabled={true}
                      mdCol={'6'}
                      form={formik}
                      values={formik.values.counselor_role}
                      onChange={formik.handleChange}
                      name={'counselor_role'}
                      label={'User Role'}
                      option={[
                        { value: USER_ROLE.student, name: 'Student', disabled: 'disabled' },
                        { value: USER_ROLE.counselor, name: 'Counselor', disabled: 'disabled' },
                      ]}
                      feedback={
                        formik.touched.counselor_role &&
                        formik.errors.counselor_role && (
                          <span className="text-danger">{formik.errors.counselor_role}</span>
                        )
                      }
                    />
                  </div>
                  <div className="col-md-6 py-2 px-2">
                    <TextIconInput
                      icon={<MailOutlineIcon />}
                      iconClass="text-primary3"
                      formClass="text-field-dark border-field-dark"
                      mdCol={'6'}
                      label={'Email*'}
                      name={'counselor_email'}
                      values={formik.values.counselor_email}
                      onChange={formik.handleChange}
                      feedback={
                        formik.touched.counselor_email &&
                        formik.errors.counselor_email && (
                          <span id="error_email" className="text-danger">
                            {formik.errors.counselor_email}
                          </span>
                        )
                      }
                    />
                  </div>
                </div>

              <div className="row py-2">
                <div className="col-md-12 mt-2 px-1">
                    <span className="text-left text-secondary fs-13px">By inviting your counselor, you are allowing your counselor to view all your GradMap summary pages and the information on them. 
                    It will enable you to access and use the chat feature to communicate with your counselor.
                    </span>
                </div>
              </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="p-0 p-md-1 d-md-flex justify-content-end">
                      <Button
                        variant="primary"
                        onClick={async () => formik.handleSubmit()}
                        className="btn-update"
                      >
                        {waiting ? (
                          <Spinner size="sm" animation="border" variant="light" />
                        ) : ('Invite')}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              
            </>
          )}

          {userRole === USER_ROLE.student && showSession === 3 && (
            <div id="add-counselor-box" className="row">
              <Col xs={12} style={{ marginTop: '34px', marginBottom: '66px' }}>
                <div
                  className="rounded border border-primary bg-primary-light border-2 d-flex flex-column flex-md-row align-items-center"
                  style={{
                    minHeight: '114px',
                    paddingLeft: '31px',
                    paddingRight: '25px',
                    justifyContent: 'space-between',
                  }}
                >
                  {/* <div className="d-flex align-items-center">
                    <PersonAddAltOutlinedIcon
                      className="text-primary"
                      width={'51px'}
                      height={'51px'}
                      style={{ fontSize: 47, minWidth: '51px', marginRight: '22px' }}
                    ></PersonAddAltOutlinedIcon>
                    <span
                      className="text-primary"
                      style={{
                        fontSize: '16px',
                        lineHeight: '22px',
                        letterSpacing: '0.02em',
                        maxWidth: '506px',
                        marginRight: '22px',
                        marginTop: '22px',
                        marginBottom: '22px',
                      }}
                    >
                      Add a counselor to accompany you in this process, it can be one of your
                      parents, your guardian / tutor or your counselor
                    </span>
                  </div> */}

                  <Button variant="primary" className="my-3" onClick={handleAddNew}>
                    Add Counselor
                  </Button>
                </div>
              </Col>
            </div>
          )}

          {userRole === USER_ROLE.counselor && showSession === 4 && (
            <div className="counselor-container">
              <div className="students-header">
                <Typography variant="h4" component="h1" className="students-title">
                  Your Students
                  <span className="students-count">{partnerList.length} students</span>
                </Typography>
                <Typography className="students-description">
                  Manage and track your assigned students' college application progress
                </Typography>
              </div>
              {/* <div className="search-bar-container">
                <input type="text" placeholder="Search students by name..." className="search-input" />
              </div> */}
              <div className="students-table-container">
                <table className="students-table">
                  <thead>
                    <tr>
                      <th>Student Name</th>
                      {/* <th>Process State <ArrowUpward className="sort-icon" /></th> */}
                      <th>Student Email</th>
                      {/* <th>Chat</th> */}
                      {/* <th>Notes <ArrowDownward className="sort-icon" /></th> */}
                      {/* <th>ToDos <ArrowUpward className="sort-icon" /></th> */}
                      {/* <th>Last Activity</th> */}
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentItems.map((row) => (
                      <tr key={row.email}>
                        <td>
                          <div className="student-name-cell">
                            <div className="student-avatar">
                              {row.first_name?.[0]}{row.last_name?.[0]}
                            </div>
                            <span className="student-name">
                              {catName(row.first_name, row.middle_name, row.last_name)}
                            </span>
                          </div>
                        </td>
                        <td><span className="student-name email" title={`Email: ${row.email}`}>
                          {row.email}</span>
                        </td>
                        {/* <td><span className="process-state-chip">{row.processState}</span></td> */}
                        {/* <td className="chat-cell">
                          <div className="icon-cell">
                            <ChatBubbleOutline /> 
                            {row.chat > 0 && <span className="chat-icon-badge">{row.chat}</span>}
                          </div>
                        </td> */}
                        {/* <td className="notes-cell">
                          <div className="icon-cell">
                            <DescriptionOutlined /> {row.notes}
                          </div>
                        </td> */}
                        {/* <td className="todos-cell">
                          <div className="icon-cell">
                            <CheckBoxOutlined /> {row.todos}
                          </div>
                        </td> */}
                        {/* <td className="last-activity-cell">
                          <div className="icon-cell">
                            <HistoryOutlined /> {row.lastActivity}
                          </div>
                        </td> */}
                        <td className="actions-cell">
                          {row?.requested_status === INVITATION_STATUS.pending && (
                            <div
                              className="d-inline-flex align-items-center justify-content-end gap-2 flex-wrap"
                              style={{ maxWidth: '100%' }}
                            >
                              <Button
                                variant="primary"
                                className={'btn-approval'}
                                onClick={async () => handleApproval(row)}
                                disabled={
                                  waiting &&
                                  currentRow?.student_id === row.student_id &&
                                  counselorListAction !== 'approve'
                                }
                              >
                                {waiting &&
                                currentRow?.student_id === row.student_id &&
                                counselorListAction === 'approve' ? (
                                  <Spinner size="sm" animation="border" variant="light" />
                                ) : (
                                  'Approval'
                                )}
                              </Button>
                              <Button
                                variant="light"
                                className={'btn-remove'}
                                onClick={async () => handleDeclinePending(row)}
                                disabled={
                                  waiting &&
                                  currentRow?.student_id === row.student_id &&
                                  counselorListAction !== 'decline'
                                }
                              >
                                {waiting &&
                                currentRow?.student_id === row.student_id &&
                                counselorListAction === 'decline' ? (
                                  <Spinner size="sm" animation="border" variant="dark" />
                                ) : (
                                  'Remove'
                                )}
                              </Button>
                            </div>
                          )}
                          {row?.requested_status === INVITATION_STATUS.approved && (
                            <Button
                              variant="light"
                              className={'btn-remove'}
                              onClick={async () => handleRemove(row)}
                              disabled={
                                waiting &&
                                currentRow?.student_id === row.student_id &&
                                counselorListAction !== 'remove'
                              }
                            >
                              {waiting &&
                              currentRow?.student_id === row.student_id &&
                              counselorListAction === 'remove' ? (
                                <Spinner size="sm" animation="border" variant="dark" />
                              ) : (
                                'Remove'
                              )}
                            </Button>
                          )}
                          {row?.requested_status === INVITATION_STATUS.removed && (
                              <Button
                                variant="light"
                                className={'btn-remove'}
                                disabled={true}
                              >
                                Removed
                              </Button>
                          )}
                          {row?.requested_status === INVITATION_STATUS.withdrawn && (
                              <Button
                                variant="light"
                                className={'btn-remove'}
                                disabled={true}
                              >
                                withdrawn
                              </Button>
                          )}
                          {row?.requested_status === INVITATION_STATUS.rejected && (
                              <Button
                                variant="light"
                                className={'btn-remove'}
                                disabled={true}
                              >
                                Rejected
                              </Button>
                          )}
                          {row?.requested_status === INVITATION_STATUS.declined && (
                              <Button
                                variant="light"
                                className={'btn-remove'}
                                disabled={true}
                              >
                                Declined
                              </Button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {totalPages > 1 && (
                  <div className="pagination-container">
                    <button 
                      className="pagination-button" 
                      onClick={handlePreviousPage}
                      disabled={currentPage === 1}
                    >
                      &lt;
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => index + 1).map((pageNumber) => (
                      <button 
                        key={pageNumber}
                        className={`pagination-button ${pageNumber === currentPage ? 'active' : ''}`}
                        onClick={() => handlePageChange(pageNumber)}
                      >
                        {pageNumber}
                      </button>
                    ))}
                    <button 
                      className="pagination-button" 
                      onClick={handleNextPage}
                      disabled={currentPage === totalPages}
                    >
                      &gt;
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
        <CounselorInviteAlertDialog open={showAlert} setOpen={setShowAlert}/>
        <div id="go-to-bottom"></div> 
      </div>
      <style scoped>{`
#new-counselor .form-control:disabled, 
#new-counselor .form-control[readonly] {
  background-color: #fff;
  opacity: 1;
}
#new-counselor input.text-field-light.border-field-light.form-control:disabled, 
#new-counselor input.text-field-light.border-field-light.form-control[readonly] {
  border-color: #8894AA !important;
  opacity: 1!important;
}

.btn.btn-approval, .btn.btn-remove {
  width: 103px!important;
  height: 44px!important;
}

.btn.btn-remove.btn-light { 
  color: #0C2551!important;
  border-color: #EFF1F5!important;
  background-color: #EFF1F5!important; 
}

.btn.btn-remove.btn-light:hover { 
  color: #fff!important;
  background-color: #DC3746!important;
  border-color: #DC3746!important;
}

    `}</style>
    </div>
  );
};

export default SettingsCounselor;
